import React from 'react';
import { Form, Col, Row, Button, Modal, Input, DatePicker } from 'antd';
import { useTranslation } from "react-i18next";

export const CUSTOMS_DATE_FORMAT = 'DD/MM/YYYY';

export const CustomsDeclModal = ({ modalVisible, setModalVisible, editingKey, form, handleAddOrSave, handleClearEdit, saving }) => {
  const { t } = useTranslation("common");

  const hideModal = () => {
    setModalVisible(false);
    handleClearEdit();
  };

  const handleSubmit = (values) => {
    editingKey !== '' ? handleAddOrSave(values, editingKey) : handleAddOrSave(values);
  };

  return (
    <Modal
      visible={modalVisible}
      onCancel={hideModal}
      footer={null}
      centered
      title={t("admin.acceptance.customsDecl")}
    >
      <Form
        name="customsDeclForm"
        labelCol={{ span: 24, offset: 0 }}
        labelAlign="left"
        wrapperCol={{ span: 24 }}
        autoComplete="off"
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
      >
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Form.Item
              name="codCusRefNum"
              label={t("admin.acceptance.custRefNumHolder")}
              rules={[{ required: true, message: t("admin.validation.required") }]}
            >
              <Input placeholder={t("admin.acceptance.custRefNumHolder")} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="datCusIss"
              label={t("admin.acceptance.custIssDateHolder")}
              rules={[{ required: true, message: t("admin.validation.required") }]}
            >
              <DatePicker
                style={{ width: '100%' }}
                format={CUSTOMS_DATE_FORMAT}
                placeholder={t("admin.acceptance.custIssDateHolder")}
              />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 10 }}>
          <Button htmlType="submit" type="primary" loading={saving} style={{ width: 'fit-content' }}>
            {editingKey !== '' ? t('admin.acceptance.saveSizeBtn') : t('admin.acceptance.addSizeBtn')}
          </Button>
          <Button onClick={hideModal} disabled={saving} style={{ width: 'fit-content' }}>
            {t('cancel')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
